function outputValue(o) {

	let text = "";

	if (o.constructor === URI) {
		text += "<" + o.getText() + ">";
	}
	else if (o.constructor === BlankNode) {
		text += o.getText();
	}
	else {
		text += '"' + o.getUnescapedText() + '"';
		if (o.getLanguage() !== null) {
			text += "@" + o.getLanguage();
		}
		else if (o.getDatatype() !== null) {
			text += "^^<" + o.getDatatype() + ">";
		}
	}
	return text;
}

function unescapeText(text) {
	const regexQuote = /\\u0022/g;
	const regexBackSlash = /\\u005C/g;
	const regexTab = /\t/g;
	text = text.replace(regexQuote, '"');
	text = text.replace(regexBackSlash, '\\');
	text = text.replace(regexTab, '\t');
	// Cater for actual \n and newline and \ in a string!
	text = text.replace(/(\\\\n)|(\\n)|(\\\\)/g, function (match) {
		return match === "\\\\n" ?
			"\\n"
			:
			match === "\\n" ?
				"\n"
				:
				"\\";
	});
	return text;
}

function URI(uri) {

	if (!uri) throw new Error("A URI resource must be supplied with a value");

	this.getValue = () => outputValue(this);
	this.getText = () => uri;
}

function BlankNode(id) {

	if (!id) throw new Error("A BlankNode resource must be supplied with a value");

	this.getText = () => id;
}

function Literal(text, language, datatype) {

	language = language || null;
	datatype = datatype || null;
	if (!text) throw new Error("A Literal resource must be supplied with a text value");
	if (typeof text !== "string") throw new Error("Literal text must be a string: " + text);
	if (language && datatype) throw new Error("Only one of language or datatype should be supplied for a Literal");

	this.getValue = () => outputValue(this);
	this.getText = () => unescapeText(text);
	this.getUnescapedText = () => text;
	this.getLanguage = () => language;
	this.getDatatype = () => datatype;
}

function LDnoop() {

	this.buildPatch = () => "Noop";
}

function LDreplaceResource() {

	let iri = null;
	let replacementIri = null;
	let data = null;
	let graph = null;
	// An empty replacement indicates that there is nothing to replace with
	let empty = false;

	this.setData = function (d) {
		// Expecting an array of LDquad instances
		if (!Array.isArray(d)) throw new Error("Expecting an array of Quad resources");
		data = d;
	};

	this.setIRI = function (i) {
		if (i.constructor !== URI) {
			throw new Error("Trying to set update IRI with wrong type: " + i.constructor);
		}
		iri = i;
	};

	this.setReplacementIRI = function (i) {
		if (i.constructor !== URI) {
			throw new Error("Trying to set update IRI with wrong type: " + i.constructor);
		}
		replacementIri = i;
	};

	this.setGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set graph with wrong type: " + g.constructor);
		}
		graph = g;
	};

	this.setEmptyReplacement = function () {
		empty = true;
	};

	this.getIRI = () => iri;
	this.getReplacementIRI = () => replacementIri;
	this.getData = () => data;
	this.getGraph = () => graph;
	this.getEmptyReplacement = () => empty;

	this.buildPatch = function () {
		const patch = "ReplaceResource";
		return patch;
	};

}

function LDinsertResource() {

	let iri = null;
	let data = null;
	let graph = null;

	this.setData = function (d) {
		// Expecting an array of LDquad instances
		if (!Array.isArray(d)) throw new Error("Expecting an array of Quad resources");
		data = d;
	};

	// This is optionally the IRI of the resource being inserted
	// It is left to the client to ensure matches the payload at the moment
	this.setIRI = function (i) {
		if (i.constructor !== URI) {
			throw new Error("Trying to set update IRI with wrong type: " + i.constructor);
		}
		iri = i;
	};

	this.setGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set insert graph with wrong type: " + g.constructor);
		}
		graph = g;
	};

	this.getIRI = () => iri;
	this.getData = () => data;
	this.getGraph = () => graph;

	this.getInsertClasses = function () {
		const typeQuads = data.filter(quad => quad.getPredicate().getText() === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type");
		const typeList = typeQuads.map(quad => quad.getObject().getText());
		return typeList;
	};

	this.buildData = function () {
		if (!data) {
			throw new Error("Trying to build a patch for an incomplete LDinsertResource resource");
		}
		const quads = data.map(quad => quad.buildTriple()).join("\n");
		return quads;
	};

	this.buildPatch = function () {
		const patch = "InsertResource " + this.buildData();
		return patch;
	};

}

function LDdeleteResource() {

	let iri = null;
	let graph = null;

	this.setIRI = function (s) {
		if (s.constructor !== URI) {
			throw new Error("Trying to set delete resource IRI with wrong type: " + s.constructor);
		}
		iri = s;
	};

	this.setGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set graph with wrong type: " + g.constructor);
		}
		graph = g;
	};

	this.getIRI = () => iri;
	this.getGraph = () => graph;

	this.buildPatch = function () {
		if (!iri) {
			throw new Error("Trying to build a patch for an incomplete LDdeleteResource resource");
		}
		const patch = "DeleteResource " + iri.getValue() + " .";
		return patch;
	};

}

function LDadd() {

	let subject = null;
	let predicate = null;
	let object = null;
	let graph = null;
	let predicateGraph = null;

	this.setSubject = function (s) {
		if (s.constructor !== URI) {
			throw new Error("Trying to set add subject with wrong type: " + s.constructor);
		}
		subject = s;
	};

	this.setPredicate = function (p) {
		if (p.constructor !== URI) {
			throw new Error("Trying to set add predicate with wrong type: " + p.constructor);
		}
		predicate = p;
	};

	this.setObject = function (o) {
		if (o.constructor !== URI && o.constructor !== Literal) {
			throw new Error("Trying to set add object with wrong type: " + o.constructor);
		}
		object = o;
	};

	this.setGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set add graph with wrong type: " + g.constructor);
		}
		graph = g;
	};

	this.setPredicateGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set add graph with wrong type: " + g.constructor);
		}
		predicateGraph = g;
	};

	this.getSubject = () => subject;
	this.getPredicate = () => predicate;
	this.getObject = () => object;
	this.getGraph = () => graph;
	this.getPredicateGraph = () => predicateGraph;

	this.buildPatch = function () {
		if (!subject || !predicate || !object) {
			throw new Error("Trying to build a patch for an incomplete LDadd resource");
		}
		const patch = "Add <" + subject.getText() + "> <" + predicate.getText() + "> " + outputValue(object) + " .";
		return patch;
	};

}

function LDdelete() {

	let subject = null;
	let predicate = null;
	let object = null;
	let graph = null;
	let predicateGraph = null;

	this.setSubject = function (s) {
		if (s.constructor !== URI) {
			throw new Error("Trying to set delete subject with wrong type: " + s.constructor);
		}
		subject = s;
	};

	this.setPredicate = function (p) {
		if (p.constructor !== URI) {
			throw new Error("Trying to set delete predicate with wrong type: " + p.constructor);
		}
		predicate = p;
	};

	this.setObject = function (o) {
		if (o.constructor !== URI && o.constructor !== Literal) {
			throw new Error("Trying to set delete object with wrong type: " + o.constructor);
		}
		object = o;
	};

	this.setGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set delete graph with wrong type: " + g.constructor);
		}
		graph = g;
	};

	this.setPredicateGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set add graph with wrong type: " + g.constructor);
		}
		predicateGraph = g;
	};

	this.getSubject = () => subject;
	this.getPredicate = () => predicate;
	this.getObject = () => object;
	this.getGraph = () => graph;
	this.getPredicateGraph = () => predicateGraph;

	this.buildPatch = function () {
		if (!subject || !predicate || !object) {
			throw new Error("Trying to build a patch for an incomplete LDdelete resource");
		}
		const patch = "Delete <" + subject.getText() + "> <" + predicate.getText() + "> " + outputValue(object) + " .";
		return patch;
	};

}

function LDupdate() {

	let subject = null;
	let predicate = null;
	let object = null;
	let objectReplacement = null;
	let graph = null;
	let predicateGraph = null;

	this.setSubject = function (s) {
		if (s.constructor !== URI) {
			throw new Error("Trying to set update subject with wrong type: " + s.constructor);
		}
		subject = s;
	};

	this.setPredicate = function (p) {
		if (p.constructor !== URI) {
			throw new Error("Trying to set update predicate with wrong type: " + p.constructor);
		}
		predicate = p;
	};

	this.setObject = function (o) {
		if (o.constructor !== URI && o.constructor !== Literal) {
			throw new Error("Trying to set update object with wrong type: " + o.constructor);
		}
		object = o;
	};

	this.setObjectReplacement = function (o) {
		if (o.constructor !== URI && o.constructor !== Literal) {
			throw new Error("Trying to set update object replacement with wrong type: " + o.constructor);
		}
		objectReplacement = o;
	};

	this.setGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set update graph with wrong type: " + g.constructor);
		}
		graph = g;
	};

	this.setPredicateGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set add graph with wrong type: " + g.constructor);
		}
		predicateGraph = g;
	};
	
	this.getSubject = () => subject;
	this.getPredicate = () => predicate;
	this.getObject = () => object;
	this.getObjectReplacement = () => objectReplacement;
	this.getGraph = () => graph;
	this.getPredicateGraph = () => predicateGraph;

	this.buildPatch = function () {
		if (!subject || !predicate || !object || !objectReplacement) {
			throw new Error("Trying to build a patch for an incomplete LDupdate resource");
		}
		const patch = "Update <" + subject.getText() + "> <" + predicate.getText() + "> " +
			outputValue(object) + " " + outputValue(objectReplacement) + " .";
		return patch;
	};
}

function LDreplace() {

	let subject = null;
	let predicate = null;
	let predicateReplacement = null;
	let object = null;
	let objectReplacement = null;
	let graph = null;

	this.setSubject = function (s) {
		if (s.constructor !== URI) {
			throw new Error("Trying to set replace subject with wrong type: " + s.constructor);
		}
		subject = s;
	};

	this.setPredicate = function (p) {
		if (p.constructor !== URI) {
			throw new Error("Trying to set replace predicate with wrong type: " + p.constructor);
		}
		predicate = p;
	};

	this.setPredicateReplacement = function (p) {
		if (p.constructor !== URI) {
			throw new Error("Trying to set replace predicate replacement with wrong type: " + p.constructor);
		}
		predicateReplacement = p;
	};

	this.setObject = function (o) {
		if (o.constructor !== URI && o.constructor !== Literal) {
			throw new Error("Trying to set replace object with wrong type: " + o.constructor);
		}
		object = o;
	};

	this.setObjectReplacement = function (o) {
		if (o.constructor !== URI && o.constructor !== Literal) {
			throw new Error("Trying to set replace object replacement with wrong type: " + o.constructor);
		}
		objectReplacement = o;
	};

	this.setGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set replace graph with wrong type: " + g.constructor);
		}
		graph = g;
	};

	this.getSubject = () => subject;
	this.getPredicate = () => predicate;
	this.getPredicateReplacement = () => predicateReplacement;
	this.getObject = () => object;
	this.getObjectReplacement = () => objectReplacement;
	this.getGraph = () => graph;

	this.buildPatch = function () {
		if (!subject || !predicate || !object || !predicateReplacement || !objectReplacement) {
			throw new Error("Trying to build a patch for an incomplete LDreplace resource");
		}
		const patch = "Replace <" + subject.getText() + "> <" + predicate.getText() + "> " +
			outputValue(object) + " <" + predicateReplacement.getText() + "> " + outputValue(objectReplacement) + " .";
		return patch;
	};

}

function LDupdateList() {

	let subject = null;
	let predicate = null;
	let startIndex = null;
	let endIndex = null;
	let replacementList = null;
	let graph = null;

	this.setSubject = function (s) {
		if (s.constructor !== URI) {
			throw new Error("Trying to set update list subject with wrong type: " + s.constructor);
		}
		subject = s;
	};

	this.setPredicate = function (p) {
		if (p.constructor !== URI) {
			throw new Error("Trying to set update list predicate with wrong type: " + p.constructor);
		}
		predicate = p;
	};

	this.setGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set update list graph with wrong type: " + g.constructor);
		}
		graph = g;
	};

	this.setStartIndex = function (s) {
		if (!Number.isInteger(s)) throw new Error("The start list index must be an integer.");
		if (endIndex && s > endIndex) throw new Error("Start index must be less than or equal to start index");
		startIndex = s;
	};

	this.setEndIndex = function (e) {
		if (!Number.isInteger(e)) throw new Error("The end list index must be an integer.");
		if (startIndex && e < startIndex) throw new Error("End index must be greater than or equal to start index");
		endIndex = e;
	};

	this.setReplacementList = function (rl) {
		if (!Array.isArray(rl)) throw new Error("List replacement should be an array.");
		const rlTypeCheck = rl.every(rlItem => rlItem instanceof URI || rlItem instanceof Literal);
		if (!rlTypeCheck) throw new Error("All items in a replacement list must be URIs or Literals");
		replacementList = rl;
	};

	this.getSubject = function () {
		return subject;
	};

	this.getPredicate = function () {
		return predicate;
	};

	this.getGraph = function () {
		return graph;
	};

	this.getStartIndex = function () {
		return startIndex;
	};

	this.getEndIndex = function () {
		return endIndex;
	};

	this.getReplacementList = function () {
		return replacementList;
	};

	this.buildPatch = function () {
		if (!subject || !predicate || !replacementList) {
			throw new Error("Trying to build a patch for an incomplete LDreplace resource");
		}

		let normalStartIndex = "";
		let normalEndIndex = "";

		if (startIndex !== -1) normalStartIndex = startIndex;
		if (endIndex !== -1) normalEndIndex = endIndex;

		const rlPatch = replacementList.map(item => outputValue(item)).join(" ");
		const patch = "UpdateList <" + subject.getText() + "> <"
			+ predicate.getText() + "> " + normalStartIndex + ".."
			+ normalEndIndex + " (" + rlPatch + ") .";

		return patch;
	};

}

function LDquad(s, p, o, g) {

	let subject = s;
	let predicate = p;
	let object = o;
	let graph = g;

	this.setSubject = function (s) {
		if (s.constructor !== URI) {
			throw new Error("Trying to set quad subject with wrong type: " + s.constructor);
		}
		subject = s;
	};

	this.setPredicate = function (p) {
		if (p.constructor !== URI) {
			throw new Error("Trying to set quad predicate with wrong type: " + p.constructor);
		}
		predicate = p;
	};

	this.setObject = function (o) {
		if (o.constructor !== URI && o.constructor !== Literal) {
			throw new Error("Trying to set quad object with wrong type: " + o.constructor);
		}
		object = o;
	};

	this.setGraph = function (g) {
		if (g.constructor !== URI) {
			throw new Error("Trying to set quad graph with wrong type: " + g.constructor);
		}
		graph = g;
	};

	this.getSubject = () => subject;
	this.getPredicate = () => predicate;
	this.getObject = () => object;
	this.getGraph = () => graph;

	this.buildTriple = function () {
		const triple = outputValue(subject) + " <" + predicate.getText() + "> " + outputValue(object) + " .";
		return triple;
	};

}

module.exports = { BlankNode, LDadd, LDdelete, LDdeleteResource, LDinsertResource, LDreplaceResource, LDnoop, LDquad, LDupdate, LDreplace, LDupdateList, Literal, URI };
